export enum LanguageEnum {
    DEFAULT = 'es',
    ENGLISH = 'en',
    SPANISH = 'es',
    FRENCH = 'fr'
}